var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../../utils/styled-components';
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-grow: 1;\n  padding: ", ";\n  overflow-y: auto;\n  color: ", ";\n  background: ", ";\n\n  @media (min-width: ", ") {\n    // IE11 Prevent layer oversizing screen height and keep scrollable\n    // max-height on parent container doesn't work when content is resizing\n    max-height: 85vh;\n  }\n"], ["\n  flex-grow: 1;\n  padding: ",
    ";\n  overflow-y: auto;\n  color: ", ";\n  background: ", ";\n\n  @media (min-width: ", ") {\n    // IE11 Prevent layer oversizing screen height and keep scrollable\n    // max-height on parent container doesn't work when content is resizing\n    max-height: 85vh;\n  }\n"])), function (_a) {
    var noContentPadding = _a.noContentPadding, component = _a.theme.component;
    return noContentPadding ? '' : component.modal.content.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.content.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.content.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.breakpoints.desktop;
});
export default Content;
var templateObject_1;
//# sourceMappingURL=index.js.map